import { USER_TYPES } from 'app/constants/Constants';

export const TRANS_CONST = {
    dealName: 'dealName',
    clientName: 'clientName',
    transactionType: 'transactionType',
    assetClass: 'assetClass',
    sector: 'sector',
    quantum: 'quantum',
    disbursementDate: 'disbursementDate',
    maturityDate: 'maturityDate',
    disbursedAmount: 'tranchesDisbursedAmount',
    principalOutstanding: 'principalOutstanding',
    yield: 'yield',
    collectionEfficiency: 'collectionEfficiency',
    residualTenor: 'residualTenor',
    flceFixedDeposit: 'flceFixedDeposit',
    maxSlceBg: 'maxSlceBg',
    other: 'other',
};

export const PTCV1_KEYS: any = {
    clientId: 'customerId',
    assetClasses: 'poolType',
};

export const INTEREST_RATE_METHOD = [
    { label: 'Coupon', value: 'Coupon' },
    { label: 'XIRR', value: 'XIRR' },
];

export const INTEREST_RATE_TYPE = [
    { label: 'Fixed', value: 'fixed' },
    { label: 'Floating', value: 'floating' },
];

export const INTEREST_RATE_SHARING_TYPE = [
    { label: 'Fixed', value: 'fixed' },
    { label: 'Variable', value: 'floating' },
];

export const PROPORTION_UNITS = [
    { value: 'percent', label: 'Percent' },
    { value: 'amount', label: 'Amount' },
];
export const PROPORTION_UNIT_VALUES = {
    AMOUNT: 'amount',
    PERCENT: 'percent',
};

export const FREQUENCY = [
    { value: 'annually', label: 'Annually' },
    { value: 'half_yearly', label: 'Half Yearly' },
    { value: 'quarterly', label: 'Quarterly' },
    { value: 'monthly', label: 'Monthly' },
];

export const PRINCIPAL_REPAYMENT = {
    PROMISED: { label: 'Promised', value: 'promised' },
    EXPECTED: { label: 'Expected', value: 'expected' },
};

export const EIS_TRAP = {
    TURBO_PAR: { label: 'TurboPar', value: 'turboPar' },
    EIS_LEAKING: { label: 'EIS Leaking', value: 'eisLeaking' },
    TRIGGER: { label: 'Trigger', value: 'trigger' },
};

export const CASHFLOW = 'cashflows';
export const WATERFALL = 'waterfall';
export const TERM_SHEET = 'term_sheet';
export const ENTERPRISE_FINANCE = 'enterprise_finance';
export const REPAYMENT_SCHEDULE = 'repayment_schedule';
export const RS_FILE = 'rs_file';
export const RS_FILES = 'rs_files';
export const DEAL_DOCUMENTS = 'deal_documents';

export const INVESTOR_LIST = {
    eligible: 'eligible',
    excluded: 'excluded',
    released: 'released',
};

export const NachMandateBank = [
    { label: 'RBL BANK', value: 'rbl' },
    { label: 'YES BANK', value: 'yes' },
    { label: 'KOTAK MAHINDRA BANK', value: 'kotak' },
    { label: 'HDFC BANK', value: 'hdfc' },
];
export const ALLOW_TL_BOOK_DEBTS = [USER_TYPES.RISK, USER_TYPES.CREDIT, USER_TYPES.OPERATIONS];

export const TRANSACTION_NAVIGATION = {
    DETAILS: 'details',
    FILES: 'fILES',
    DEAL_PERFORMANCE: 'deal_performane',
    MARKET_RESEARCH: 'market_research',
    SERVICER_REPORT: 'servicer_report',
    INVESTMENT_NOTE: 'investment_note',
    REPORTS: 'reports',
    CASHFLOW_STATEMENT: 'cashflow_statement',
};

export const POOLS_COUNTERPARTIES = ['auditors', 'trustees', 'ratingAgencies', 'lawFirms'];
